import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private _searchError$ = new BehaviorSubject<string | boolean>(false);
  private _compareError$ = new BehaviorSubject<string | boolean>(false);
  private _templateApiError$ = new BehaviorSubject<string | boolean>(false);

  public get searchError$(): Observable<string | boolean> {
    return this._searchError$.asObservable();
  }

  public get compareError$(): Observable<string | boolean> {
    return this._compareError$.asObservable();
  }

  public get templateApiError$(): Observable<string | boolean> {
    return this._templateApiError$.asObservable();
  }

  /**
   * Set this error, when search or list request failed.
   * @param value Error Message
   */
  public setSearchError(value: string | boolean): void {
    this._searchError$.next(value);
  }

  /**
   * Set this error, to show an error on the compare page
   * @param value Error Message or boolean
   */
  public setCompareError(value: string | boolean): void {
    this._compareError$.next(value);
  }

  /**
   * Set this error, to show an error on the Template Editor
   * @param value Error Message or boolean
   */
  public setTemplateApiError(value: string | boolean): void {
    this._templateApiError$.next(value);
  }
}
